<template>
  <quill-editor
    :value="data"
    :options="editorOption"
    @change="$emit('change', $event)"
  >
  </quill-editor>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'bullet' }],
            [{ 'align': [] }],
            ['clean']
          ]
        }
      },
      content: `...`,
    }
  },
  components: {
    quillEditor,
  }
}
</script>
